<ng-container *ngIf="errorStatus$ | async as errorStatus">
  {{ errorStatus }}:
</ng-container>
{{ errorMessage$ | async }}
